import Dialog from "@app/common/components/material_ui/Dialog";
import t from "prop-types";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import { Paper } from "@material-ui/core";
import { trackEvent } from "@amplio-common/analytics";
import { Trans } from "@lingui/macro";

import { css } from "@emotion/react";
import theme from "@app/theme";
import { getSupportEmail } from "@amplio-common/funcs/commonFunctionalities";
import { BOTTOM_PANNEL_DIALOG_Z_INDEX } from "@app/constants";

const helpCenterURL = "https://www.poppins.co.il/";
// so far the company changed name (and domain) and the link multiple times. please update the counter below whenever you change the link
// company name changes (domain): 2
// total times the link changed: 5


const diagRootStyle = css`
  .titleDiv {
    text-align: center;
    color: ${theme.amplioColor};
  }
`;

const rootStyle = ({ colors }) => css`
  display: flex;
  justify-content: space-between;
  min-width: 550px;
  padding: 0 40px 20px;

  > div > div {
    margin-bottom: 10px;
  }

  svg {
    color: ${theme.amplioColor};
    color: ${colors.primary.main};
    margin-right: 17px;
    margin-bottom: -6px;
  }

  a {
    color: ${colors.text.main};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .suppoer-link > a {
    display: flex;
    justify-content: space-between;
  }

  .help-box {
    text-decoration: none !important;
    display: block;
    padding: 15px 22px;
    text-align: center;
    font-weight: 500;

    .qm-box {
      padding: 4px 16px;
      border-radius: 4px;
      margin-bottom: 10px;
      border: solid ${colors.primary.main};
      color: ${colors.primary.main};
      border-width: 7px 3px 3px 3px;
      display: inline-block;
    }
  }
`;

const SupportDialog = (props) => {
  const { closeDialog } = props;

  const supportEmail = getSupportEmail();

  return (
    <Dialog
      open
      maxWidth="xl"
      title={<Trans>how can we help?</Trans>}
      cancelAction={closeDialog}
      noCancelButton
      style={{ zIndex: BOTTOM_PANNEL_DIALOG_Z_INDEX }}
      disableEnforceFocus
      css={diagRootStyle}
      content={(
        <div css={rootStyle}>
          <div>
            <div className="suppoer-link">
              <a href={`mailto:${supportEmail}`} target="_blank" rel="noopener noreferrer">
                {supportEmail}
                <EmailIcon />
              </a>
            </div>
            <div className="suppoer-link">
              <a href="tel:+972 3 568-8855" target="_blank" rel="noopener noreferrer">
                03-568-8855
                <PhoneIcon />
              </a>
            </div>
          </div>
          <div>
            <Paper elevation={3} onClick={() => trackEvent("support_help_center_click")}>
              <a className="help-box" href={helpCenterURL} target="_blank" rel="noopener noreferrer">
                <div className="qm-box">?</div>
                <div><Trans>Help Center</Trans></div>
              </a>
            </Paper>
          </div>
        </div>
        )}
    />
  );
};

SupportDialog.propTypes = {
  closeDialog: t.func.isRequired,
};

export default SupportDialog;
